import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/views/login'], resolve),
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/Myold/About.vue')
  },
  {
    path: '/traffic',
    name: 'traffic',
    component: () => import('../views/Myold/traffic/index')
  },
  
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/indexbar',
    name: 'Indexbar',
    component: () => import('../views/indexbar.vue')
  },
  {
    path: '/selfreg',
    name: 'Selfreg',
    component: () => import('../views/Selfreg.vue')
  },
  {
    path: '/equipment',
    name: 'equipment',
    component: () => import('../views/equipment.vue')
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/Myold/traffic/feedback.vue')
  },
  {
    path: '/trees',
    name: 'trees',
    component: () => import('../views/Myold/traffic/trees.vue')
  },

  {
    path: '/daily',
    name: 'daily',
    component: () => import('../views/Myold/traffic/daily.vue')
  },
  {
    path: '/record',
    name: 'record',
    component: () => import('../views/Myold/traffic/record.vue')
  },

  {
    path: '/Homerote',
    name: 'Homerote',
    component: () => import('../views/Homerote.vue')
  },
  {
    path: '/Homemake',
    name: 'Homemake',
    component: () => import('../views/Homemake.vue')
  },
  {
    path: '/Homekey',
    name: 'Homekey',
    component: () => import('../views/Homekey.vue')
  },

  {
    path: '/Homeqr',
    name: 'Homekey',
    component: () => import('../views/Homeqr.vue')
  },
  {
    path: '/Homeble',
    name: 'Homeble',
    component: () => import('../views/Homeble.vue')
  },

  {
    path: '/regin',
    name: 'regin',
    component: () => import('../views/regin.vue')
  },

  {
    path: '/retpassword',
    name: 'retpassword',
    component: () => import('../views/Retpassword.vue')
  },
  {
    path: '/changpas',
    name: 'Changpas',
    component: () => import('../views/Changpas.vue')
  },
  {
    path: '/netlist',
    name: 'netlist',
    component: () => import('../views/netlist.vue')
  },
  {
    path: '/Exempt',
    name: 'Exempt',
    component: () => import('../views/Exempt.vue')
  },
  {
    path: '/admin/dept',
    name: 'deptAdmin',
    component: () => import('../views/admin/dept.vue')
  },
  {
    path: '/admin/person',
    name: 'personAdmin',
    component: () => import('../views/admin/person.vue')
  },
  {
    path: '/admin/personAdd',
    name: 'personAddAdmin',
    component: () => import('../views/admin/personAdd.vue')
  },
  {
    path: '/admin/key',
    name: 'keyAdmin',
    component: () => import('../views/admin/key.vue')
  },
  {
    path: '/admin/doorCard',
    name: 'doorCardAdmin',
    component: () => import('../views/admin/doorCard.vue')
  },
  {
    path: '/admin/face',
    name: 'faceAdmin',
    component: () => import('../views/admin/face.vue')
  },
  {
    path: '/admin/password',
    name: 'passwordAdmin',
    component: () => import('../views/admin/password.vue')
  },
  {
    path: '/admin/power',
    name: 'powerAdmin',
    component: () => import('../views/admin/power.vue')
  },
  {
    path: '/admin/examine',
    name: 'examineAdmin',
    component: () => import('../views/admin/examine.vue')
  },
  {
    path: '/deviceSearch',
    name: 'deviceSearch',
    component: () => import('../views/deviceSearch.vue')
  },
  {
    path: '/network',
    name: 'network',
    component: () => import('../views/network.vue')
  },
  {
    path: '/admin/personEdit',
    name: 'personEdit',
    component: () => import('../views/admin/personEdit.vue')
  },
]

const router = new VueRouter({
  routes
})

const whiteList = ['/login','/regin','/retpassword','/indexbar','/register']

router.beforeEach((to,from,next)=>{
  const user = window.localStorage.getItem('getTokendata')

  if (user) {   // 登录
    if (to.path === '/login') {  
      // 如果已登录，请重定向到主页
      next({ path: '/' })
      return
    } 
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免费登录白名单中，直接进入
      next()
    } else {
      // 没有访问权限的其他页将重定向到登录页。
      next(`/login`)
    }
  }
  
})

export default router
